// A faint full-width line with a soft blue glow travelling along it: the hero's signal, still running. Reduced
// motion keeps the line and drops the glow.
export function SignalLine() {
  return (
    <div aria-hidden="true" className="relative h-px w-full overflow-hidden bg-char/10">
      <span
        data-signal
        className="absolute inset-y-0 left-0 w-1/3 animate-signal bg-gradient-to-r from-transparent via-brand-500 to-transparent motion-reduce:hidden"
      />
    </div>
  );
}
